import { Component, Directive, ElementRef, inject, Injector, Input, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UpgradeComponent } from '@angular/upgrade/static';

@Directive({
  selector: 'goals-list-directive',
  standalone: false
})
export class GoalsListDirective extends UpgradeComponent {
  @Input() filterId: string;

  constructor(elementRef: ElementRef, injector: Injector) {
    super('goalsListComponent', elementRef, injector);
  }
}

@Component({
  selector: 'goals-list-component',
  template: '<goals-list-directive [filterId]="filterId"></goals-list-directive>',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class GoalsListComponent {
  @Input() filterId: string;
}

@Directive({
  selector: 'user-goals-directive',
  standalone: false
})
export class UserGoalsDirective extends UpgradeComponent {
  @Input() filterId: string;
  @Input() user: string;

  constructor(elementRef: ElementRef, injector: Injector) {
    super('userGoalsComponent', elementRef, injector);
  }
}

@Component({
  selector: 'user-goals-component',
  template: '<user-goals-directive [filterId]="filterId" [user]="user"></user-goals-directive>',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class UserGoalsComponent {
  @Input() filterId: string;
  @Input() user: string;
}

@Directive({
  selector: 'goal-view-directive',
  standalone: false
})
export class GoalViewDirective extends UpgradeComponent {
  @Input() goalId: string;
  @Input() periodId: string;
  @Input() action: string;

  constructor(elementRef: ElementRef, injector: Injector) {
    super('goalComponent', elementRef, injector);
  }
}

@Component({
  selector: 'goal-view-component',
  template: '<goal-view-directive [goalId]="goalId" [periodId]="periodId" [action]="action"></goal-view-directive>',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class GoalViewComponent {
  @Input() goalId: string;
  @Input() periodId: string;
  protected action: string;

  private route = inject(ActivatedRoute);

  constructor() {
    this.route.data.subscribe(data => {
      this.action = data['action'];
    });
  }
}

@Directive({
  selector: 'goal-edit-directive',
  standalone: false
})
export class GoalEditDirective extends UpgradeComponent {
  @Input() goalId: string;
  @Input() eventId: string;
  @Input() sectionId: string;
  @Input() fieldId: string;
  @Input() action: string;
  @Input() user: string;

  constructor(elementRef: ElementRef, injector: Injector) {
    super('goalsDefinitionComponent', elementRef, injector);
  }
}

@Component({
  selector: 'goal-edit-component',
  template: '<goal-edit-directive [goalId]="goalId" [eventId]="eventId" [sectionId]="sectionId" [fieldId]="fieldId" [action]="action" [user]="user"></goal-edit-directive>',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class GoalEditComponent {
  @Input() goalId: string;
  @Input() eventId: string;
  @Input() sectionId: string;
  @Input() fieldId: string;
  @Input() user: string;
  protected action: string;

  private route = inject(ActivatedRoute);

  constructor() {
    this.route.data.subscribe(data => {
      this.action = data['action'];
    });
  }
}

@Directive({
  selector: 'targets-link-directive',
  standalone: false
})
export class TargetsLinkDirective extends UpgradeComponent {
  @Input() goalId: string;
  @Input() targetId: string;
  @Input() periodId: string;

  constructor(elementRef: ElementRef, injector: Injector) {
    super('targetsLinkComponent', elementRef, injector);
  }
}

@Component({
  selector: 'targets-link-component',
  template: '<targets-link-directive [goalId]="goalId" [targetId]="targetId" [periodId]="periodId"></targets-link-directive>',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class TargetsLinkComponent {
  @Input() goalId: string;
  @Input() targetId: string;
  @Input() periodId: string;
}

@Directive({
  selector: 'manage-categories-directive',
  standalone: false
})
export class ManageCategoriesDirective extends UpgradeComponent {
  constructor(elementRef: ElementRef, injector: Injector) {
    super('manageCategoriesComponent', elementRef, injector);
  }
}

@Component({
  selector: 'manage-categories-component',
  template: '<manage-categories-directive></manage-categories-directive>',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ManageCategoriesComponent {
}
